import { statusScalar } from '../actions/activity.js';
import { statusItemId } from '../statuses/expiry.js';
import { isSelfStatusOrigin } from '../statuses/status-origin.js';
import { CONTINGENCY_ARMING_IDS } from './sanguine-gate.js';
import { type Row, upper } from '../ability/context.js';

/** Adoption hydrates stored payloads as inputs; the damage/combat boundary decides whether they fire. */
export function contingencySpellIds(statuses: readonly Row[]): string[] {
  return [...new Set(statuses.filter(st => CONTINGENCY_ARMING_IDS.includes(statusItemId(st)) && !Number(statusScalar(st, 'status_deleted') ?? 0))
    .map(st => { const id = upper(statusScalar(st, 'status_origin_id')); return isSelfStatusOrigin(upper(statusScalar(st, 'status_id')), id) ? '' : id; })
    .filter(id => /^[0-9A-F]{8}(?:-[0-9A-F]{4}){3}-[0-9A-F]{12}$/.test(id)))];
}
